import { Icon } from '@coast/schemas';
import { isNil } from 'lodash';
import { i18n } from '@shared/util/i18n';
import { isInputComponent, isTagComponent, isTextComponent } from './utils';
const MULTI_LINE = 'multi-line';

export function getLabel(component: MBAPI.WorkflowTemplate_components): string {
  if (isTagComponent(component)) {
    return component.multiselect
      ? i18n('workflowTemplate.component.type.label.multiSelect')
      : i18n('workflowTemplate.component.type.label.singleSelect');
  }
  if (isTextComponent(component)) {
    return component.multiline
      ? i18n('workflowTemplate.component.type.label.longText')
      : i18n('workflowTemplate.component.type.label.shortText');
  }
  return COMPONENT_TYPE_LABEL_MAP[component.type];
}

export function getIcon(component: MBAPI.WorkflowTemplate_components): Icon | undefined {
  if (isInputComponent(component) && !isNil(component.icon)) {
    return component.icon as Icon;
  }
  if (isTagComponent(component)) {
    return component.multiselect ? 'list' : 'single-select-list';
  }
  if (isTextComponent(component)) {
    return component.multiline ? MULTI_LINE : 'title-t';
  }
  return COMPONENT_TYPE_ICON_MAP[component.type];
}

export const COMPONENT_TYPE_LABEL_MAP: Record<MBAPI.ComponentType, string> = {
  ADDRESS: i18n('workflowTemplate.component.type.label.address'),
  AUDIT_CHECKBOX: i18n('workflowTemplate.component.type.label.auditCheckbox'),
  AUDIT_TAG: i18n('workflowTemplate.component.type.label.auditTag'),
  AUDIT_TEXT: i18n('workflowTemplate.component.type.label.auditText'),
  COMBINED_TAGS: i18n('workflowTemplate.component.type.label.combinedTags'),
  DATE: i18n('workflowTemplate.component.type.label.date'),
  DATE_RANGE: i18n('workflowTemplate.component.type.label.dateRange'),
  EMAIL: i18n('workflowTemplate.component.type.label.email'),
  URL: i18n('workflowTemplate.component.type.label.url'),
  FILE: i18n('workflowTemplate.component.type.label.file'),
  GEOLOCATION: i18n('workflowTemplate.component.type.label.geolocation'),
  INPUT_BUTTON: i18n('workflowTemplate.component.type.label.button'),
  NUMBER: i18n('workflowTemplate.component.type.label.number'),
  PERSON: i18n('workflowTemplate.component.type.label.person'),
  RELATED_CARD: i18n('workflowTemplate.component.type.label.relatedCard'),
  RELATED_CARD_LOOKUP: i18n('workflowTemplate.component.type.label.relatedCardLookup'),
  SCHEDULED_AUTOMATION: i18n('workflowTemplate.component.type.label.scheduledAutomation'),
  SIGNATURE: i18n('workflowTemplate.component.type.label.signature'),
  STATIC_TEXT: i18n('workflowTemplate.component.type.label.staticText'),
  SUBFORM: i18n('workflowTemplate.component.type.label.subform'),
  TAG: i18n('workflowTemplate.component.type.label.singleSelect'),
  TEXT: i18n('workflowTemplate.component.type.label.shortText'),
  TODO: i18n('workflowTemplate.component.type.label.todo'),
  TIME_TRACKER: i18n('workflowTemplate.component.type.label.timeTracker'),
  REFERENCED_IN: i18n('workflowTemplate.component.type.label.referencedIn'),
  ENTITY_BATCH: i18n('workflowTemplate.component.type.label.entityBatch'),
};

export const COMPONENT_TYPE_ICON_MAP: Record<MBAPI.ComponentType, Icon> = {
  ADDRESS: 'pin-location',
  AUDIT_CHECKBOX: 'check-task',
  AUDIT_TAG: 'single-select-list',
  AUDIT_TEXT: MULTI_LINE,
  DATE: 'calendar',
  DATE_RANGE: 'event-create',
  COMBINED_TAGS: 'tag',
  EMAIL: 'envelope',
  URL: 'link',
  FILE: 'file',
  GEOLOCATION: 'avatar-location',
  INPUT_BUTTON: 'button-press',
  NUMBER: 'hashtag',
  PERSON: 'avatar',
  RELATED_CARD: 'duplicate-squares',
  RELATED_CARD_LOOKUP: 'search-look-up',
  SIGNATURE: 'signature-ballpoint-pen',
  STATIC_TEXT: MULTI_LINE,
  SCHEDULED_AUTOMATION: 'time-alarm',
  SUBFORM: 'list',
  TAG: 'single-select-list',
  TEXT: 'title-t',
  TODO: 'check-task',
  TIME_TRACKER: 'time-stopwatch',
  REFERENCED_IN: 'arrow-move-right',
  ENTITY_BATCH: 'id-symbol',
};
